import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import { UALProvider } from "ual-reactjs-renderer";
import { Helmet } from "react-helmet";
import {
  Modal,
  ModalContent,
  Spinner,
  SpinnerRed,
  SpinnerBlue,
  SpinnerGreen,
  GameButton,
} from "../components/LeftDiv";
import {
  wax,
  anchor,
  myChain,
  wombat,
  currentWebsiteURL,
  APP_NAME,
  currentUsername,
} from "../data/config";

import {
  MainButton,
  MilestoneContainer,
  MilestoneDescription,
  NewListingBody,
  NewListingCont,
  RecentFarmsContainer,
  TallFiltersCont,
  TallFiltersInnerCont,
  WideInputInnerCont,
} from "../Styles";
import LoadingPage from "../components/LoadingPage";

import { useGetSingleListing } from "../components/CustomHooks/useGetSingleListing";
import { useCheckAvailability } from "../components/CustomHooks/useCheckAvailability";
import { buyListing, get_total_discount, handleNameToCheckChange, listingRequirementsAreMet, requirement_is_met, showFungibleIngredientTable, showNftIngredientTitle, showOpText } from "../data/functions/listing_page_functions";
import useGetRequiredNfts from "../components/CustomHooks/useGetRequiredNfts";
import FarmNFTCard from "../components/FarmNFTCard";
import WhitelistNftCard from "../components/WhitelistNftCard";
import useGetWhitelistNfts from "../components/CustomHooks/useGetWhitelistNfts";
import LoadingDiv from "../components/LoadingDiv";
import { useGetBlacklist } from "../components/CustomHooks/useGetBlacklist";

const ListingPage = ({ location }) => {
  const {
    enterModalText,
    setEnterModalText,
    loadingDisplay,
    setLoadingDisplay,
    setEnterButtonsDisplay,
    enterModalDisplay,
    setEnterModalDisplay,
  } = useStateContext();


  const { ListingID } = useParams();

  const [assetVector, setAssetVector] = useState([]);
  const [whitelistVector, setWhitelistVector] = useState([]);
  const [tokenVector, setTokenVector] = useState([]);
  const [nameToCheck, setNameToCheck] = useState("");
  const [activeKey, setActiveKey] = useState("");
  const [ownerKey, setOwnerKey] = useState("");
  const [satisfiedFungibles, setSatisfiedFungibles] = useState([]);
  const [satisfiedNfts, setSatisfiedNfts] = useState([]);
  const [satisfiedWhitelists, setSatisfiedWhitelists] = useState([]);
  const [discountApplied, setDiscountApplied] = useState(0);
  const [list, getList, blacklistLoading] = useGetBlacklist();


  //custom hooks
  const [listingData, getListingData, dataIsLoading] = useGetSingleListing();
  const [isAvailable, getAvailability, checkIsLoading, lastNameChecked] = useCheckAvailability();
  const [nfts, getRequiredNfts, loadingStates, fetchAttempts] = useGetRequiredNfts();
  const [whitelistNfts, getWhitelistNfts, wlistLoadingStates, wlistFetchAttempts] = useGetWhitelistNfts();

  useEffect(() => {
    let isMounted = true;

    if(isMounted){
      getListingData(ListingID)
    }

    return () => {
      isMounted = false;
    }    
  }, [])

  useEffect(() => {
    let isMounted = true;

    if(isMounted && !dataIsLoading && listingData?.account_for_sale){
      getList(listingData?.account_for_sale)
    }

    return () => {
      isMounted = false;
    }
    
  }, [dataIsLoading, listingData])  
  
  
  

  if (listingData != null && !dataIsLoading) {
    return (
      <div id="seo">
        <Helmet>
          <title>Listing {ListingID} Details</title>
          <meta
            name="description"
            content={`${ListingID}`}
          />
          <link rel="canonical" href={`${currentWebsiteURL}/listing/${ListingID}`} />
        </Helmet>

        <UALProvider
          chains={[myChain]}
          authenticators={[anchor, wax, wombat]}
          appName={APP_NAME}
        >
          <Modal className={enterModalDisplay}>
            <ModalContent>{enterModalText}</ModalContent>

            <Spinner style={{ display: loadingDisplay }}>
              <SpinnerRed />
              <SpinnerBlue />
              <SpinnerGreen />
            </Spinner>

            <br />
            <GameButton onClick={() => setEnterModalDisplay("hidden")}>
              Close Window
            </GameButton>
          </Modal>

                <NewListingCont>
              <NewListingBody>

                <TallFiltersCont>
                    <h2>Buy A .{listingData.account_for_sale} Name</h2>
                    <br/>
                    <TallFiltersInnerCont>
                        <MilestoneDescription>
                            Check Name Availability:&nbsp;
                            <input 
                                placeholder="e.g. john"
                                value={nameToCheck}
                                maxLength={
                                    listingData.account_for_sale.length > 10 ?
                                     0 :
                                     11 - listingData.account_for_sale.length
                                }
                                onChange={(e) => {
                                  handleNameToCheckChange(e, setNameToCheck)                                    
                                }}
                            />
                            <br/>

                            <MainButton
                              gray={list?.findIndex(subname => subname.subdomain === nameToCheck) > -1}
                                disabled={list?.findIndex(subname => subname?.subdomain === nameToCheck) > -1}
                                onClick={() => {
                                    getAvailability(String(nameToCheck + "." + listingData?.account_for_sale))
                                }}
                            >
                              {

                                list?.findIndex(subname => subname.subdomain === nameToCheck) > -1
                              
                              
                              ? `${nameToCheck}.${listingData.account_for_sale} is blacklisted` : `Check ${nameToCheck}.${listingData.account_for_sale}`}
                                
                            </MainButton>

                            {!checkIsLoading ? (
                                <span className={lastNameChecked != String(nameToCheck + "." + listingData.account_for_sale) && "hidden"}> 
                                    {"  "}{lastNameChecked} is{" "}
                                {isAvailable ? "Available!" : "Not available"}
                                </span>
                            ) : (
                                <span>
                                    {" Loading..."}
                                </span>
                            )}
                        </MilestoneDescription>
                    </TallFiltersInnerCont>
                </TallFiltersCont>

                <MilestoneContainer className={(listingData.max_discount_percent == 0 || listingData.fungible_prices.prices.length == 0 ) && "hidden"}>
                  Note: You can get up to {Number(listingData.max_discount_percent * 100).toFixed(0)}% off of the fungible prices on this listing{" "}
                  by meeting certain requirements.
                </MilestoneContainer>

                <TallFiltersCont>
                    <h2>Public Keys</h2>
                    <br/>
                    <WideInputInnerCont>
                        <MilestoneDescription>
                           Enter the <b className="text-white">public</b> keys that you want to use for your new account.{" "}
                           It is generally good practice to use a different owner key and active key.

                           <br/><br/>
           
                  <div style={{
                          width: "90%",
                          clear: "both",
                          border: "1px solid rgba(133, 100, 4, 0.7)", 
                          marginLeft: "auto",
                          marginRight: "auto",
                          marginTop: "15px",
                          marginBottom: "20px",
                          backgroundColor: "rgba(133, 100, 4, 0.4)",
                          borderRadius: "5px",
                          color: "#eda702",
                          padding: "10px",
                          fontSize: "14px",
                        }}>
                            You are solely responsible for safeguarding your keys and any disclosure or loss is your own responsibility.
                        </div>

                           <h3 className="text-white">Owner Key</h3>
                            <input 
                                placeholder="e.g. PUB_K1abcsldgjhsdlkfa"
                                value={ownerKey}
                                maxLength={100}
                                onChange={(e) => {
                                    setOwnerKey(e.target.value)
                                }}
                            />
                            <br/><br/>

                            <h3 className="text-white">Active Key</h3>
                            <input 
                                placeholder="e.g. PUB_K1abcsldgjhsdlkfa"
                                value={activeKey}
                                maxLength={100}
                                onChange={(e) => {
                                    setActiveKey(e.target.value)
                                }}
                            />

                        </MilestoneDescription>
                    </WideInputInnerCont>
                </TallFiltersCont>

                
                {listingData.fungible_prices.prices.length > 0 && (
                        <TallFiltersCont>
                            <h2>Fungible Ingredients</h2>
                            <br/>
                            <TallFiltersInnerCont>
                            {showOpText(listingData.fungible_prices.op, listingData.fungible_prices.quantity)}

                            {requirement_is_met("fungible", "", satisfiedFungibles, 
                              setSatisfiedFungibles, satisfiedNfts, setSatisfiedNfts, satisfiedWhitelists, setSatisfiedWhitelists, 
                              listingData.fungible_prices, listingData.nft_prices, listingData.required_proof_nfts, listingData.max_discount_percent, 
                              discountApplied, setDiscountApplied, tokenVector, assetVector, whitelistVector) && (<span>
                                <MilestoneContainer>Fungible requirements are met!</MilestoneContainer>
                              </span>)}

                            {Number(get_total_discount(listingData.max_discount_percent, satisfiedNfts, listingData.nft_prices.prices)) > 0 && (
                              <MilestoneContainer>
                                Discounts applied are reflected in the table below
                              </MilestoneContainer>
                            )}
                            
                            {showFungibleIngredientTable(listingData.fungible_prices.prices, tokenVector, setTokenVector, listingData.max_discount_percent, satisfiedNfts, listingData.nft_prices.prices)}
                              
                            </TallFiltersInnerCont>
                        </TallFiltersCont>
                )}


                {listingData.nft_prices.prices.length > 0 && (
                        <TallFiltersCont>
                            <h2>NFT Ingredients</h2>
                            <br/>
                            <TallFiltersInnerCont>
                            {showOpText(listingData.nft_prices.op, listingData.nft_prices.quantity)}
                            
                            
                            {listingData.nft_prices.prices.map((item, index) => (
                            <span key={index}>
                              {showNftIngredientTitle(item)}

                              {requirement_is_met("nft_price", index, satisfiedFungibles, 
                              setSatisfiedFungibles, satisfiedNfts, setSatisfiedNfts, satisfiedWhitelists, setSatisfiedWhitelists, 
                              listingData.fungible_prices, listingData.nft_prices, listingData.required_proof_nfts, listingData.max_discount_percent, 
                              discountApplied, setDiscountApplied, tokenVector, assetVector, whitelistVector) && (<span>
                                <MilestoneContainer>This requirement is met</MilestoneContainer>
                              </span>)}

                              <MilestoneContainer className={(listingData.max_discount_percent == 0 || listingData.fungible_prices.prices.length == 0 || item.discount_percent == 0 ) && "hidden"}>
                              {Number(item.discount_percent * 100).toFixed(0)}% discount if you provide this ingredient 
                              </MilestoneContainer>
                                                            
                                <br/><br/>
                                {fetchAttempts[index] > 0 && nfts.find(nft => nft.index === index)?.nfts.length === 0 && (
                                  <span>
                                    No NFTs found
                                    <br/><br/>
                                  </span> 
                                )}  


                                <MainButton className={(nfts.find(nft => nft.index === index)?.nfts.length > 0 || loadingStates[index] ) ? 'hidden' : ''}
                                  onClick={() => {
                                    getRequiredNfts( currentUsername,
                                      index,
                                      item.filter_by,
                                      item.collection_name,
                                      item.schema_name,
                                      item.template_id,
                                      item.attributes)
                                  }}
                                >
                                  Scan Wallet {fetchAttempts[index] > 0 && "Again"}
                                </MainButton>


                                <span className={!loadingStates[index] && "hidden"}>
                                  <LoadingDiv />
                                </span>
                              

                                {nfts.find(nft => nft.index === index)?.nfts.length > 0 && (
                                  <RecentFarmsContainer>
                                    {nfts.find(nft => nft.index === index)?.nfts.map((nft, nft_index) => (
                                      <span key={nft_index}>
                                  <FarmNFTCard item={nft} assetVector={assetVector} setAssetVector={setAssetVector} whitelistVector={whitelistVector} setWhitelistVector={setWhitelistVector} listing_index={index}  />
                                  </span>
                                  ))}
                                  </RecentFarmsContainer>
                                )}
                                <br/><br/>
                            </span>
                        ))}                                
                            </TallFiltersInnerCont>
                        </TallFiltersCont>
                )}

                {listingData.required_proof_nfts.length > 0 && (
                        <TallFiltersCont>
                            <h2>Whitelist Requirements</h2>
                            <br/>
                            <TallFiltersInnerCont>
                            <h2>This listing has whitelist requirements. You must hold the following NFTs in your wallet:</h2>
                           
                            
                            {listingData.required_proof_nfts.map((item, index) => (
                            <span key={index}>
                                {showNftIngredientTitle(item)} 
                                <br/><br/>
                                {wlistFetchAttempts[index] > 0 && whitelistNfts.find(nft => nft.index === index)?.nfts.length === 0 && (
                                  <span>
                                    No NFTs found
                                    <br/><br/>
                                  </span> 
                                )}  

                                <MainButton className={(whitelistNfts.find(nft => nft.index === index)?.nfts.length > 0 || wlistLoadingStates[index]) ? 'hidden' : ''}
                                  onClick={() => {
                                    getWhitelistNfts( currentUsername,
                                      index,
                                      item.filter_by,
                                      item.collection_name,
                                      item.schema_name,
                                      item.template_id,
                                      item.attributes)
                                  }}
                                >
                                  Scan Wallet {wlistFetchAttempts[index] > 0 && "Again"}
                                </MainButton>

                                <span className={!wlistLoadingStates[index] && "hidden"}>
                                  <LoadingDiv />
                                </span>                                

                                {whitelistNfts.find(nft => nft.index === index)?.nfts.length > 0 && (
                                  <RecentFarmsContainer>
                                    {whitelistNfts.find(nft => nft.index === index)?.nfts.map((nft, nft_index) => (
                                      <span key={nft_index}>
                                  <WhitelistNftCard item={nft} assetVector={assetVector} setAssetVector={setAssetVector} whitelistVector={whitelistVector} setWhitelistVector={setWhitelistVector} listing_index={index} />
                                  </span>
                                  ))}
                                  </RecentFarmsContainer>
                                )}
                                <br/><br/>
                            </span>
                        ))}                               
                            </TallFiltersInnerCont>
                        </TallFiltersCont>
                )}
              

            
                <TallFiltersCont>
                    <div className="w-100 text-center justify-center mt-4">
                      {/* {listingRequirementsAreMet(listingData, assetVector, whitelistVector, tokenVector) ? "true" : "false"} */}

                        {get_total_discount(listingData.max_discount_percent, satisfiedNfts, listingData.nft_prices.prices) > 0 && (
                          <div style={{width: "90%", marginLeft:"auto", marginRight:"auto"}}>
                          <MilestoneContainer>
                            A discount of {Number(get_total_discount(listingData.max_discount_percent, satisfiedNfts, listingData.nft_prices.prices)) * 100}% has been applied to your order!
                          </MilestoneContainer>
                          <br/>
                          </div>
                        )}

                      <MainButton
                        gray={ownerKey.length < 1 || activeKey.length < 1 || nameToCheck.length < 1}
                        onClick={() => {
                          buyListing(ListingID, nameToCheck, listingData.account_for_sale, tokenVector, whitelistVector, assetVector, activeKey, ownerKey, setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay, get_total_discount(listingData.max_discount_percent, satisfiedNfts, listingData.nft_prices.prices))
                        }}
                        disabled={ownerKey.length < 1 || activeKey.length < 1 || nameToCheck.length < 1}
                      >
                        {ownerKey.length < 1 || activeKey.length < 1 || nameToCheck.length < 1 ? "Missing Info" :
                        `Buy ${String(nameToCheck + "." + listingData.account_for_sale)}`
                        }
                        
                      </MainButton>
                    </div>
                </TallFiltersCont>
              </NewListingBody>
              </NewListingCont>

        </UALProvider>
        <br />
        <br />
        <br />
      </div>
    );
  } else {
    return <LoadingPage />;
  }
};

export default ListingPage;
